export default __webpack_public_path__ + "static/media/User_cicrle.651cb302.svg";